import damp from './math/damp.js';
export default function scrollTo(selectorElement) {
  var {
    offset = 0,
    dampFactor = 0.2
  } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var targetElement = null;

  if (selectorElement instanceof HTMLElement) {
    targetElement = selectorElement;
  } else {
    targetElement = document.querySelector(selectorElement);
  }

  if (!targetElement) {
    return Promise.resolve(window.pageYOffset);
  }

  var sizes = targetElement.getBoundingClientRect();
  var scrollMargin = getComputedStyle(targetElement).scrollMarginTop || '0';
  var max = document.body.offsetHeight - window.innerHeight;
  var scrollTarget = sizes.top + window.pageYOffset + parseInt(scrollMargin, 10) + offset;

  if (scrollTarget > max) {
    scrollTarget = max;
  }

  return new Promise(resolve => {
    var isScrolling = false;
    var scroll = window.pageYOffset;
    var dampScroll = window.pageYOffset;

    function eventHandler() {
      isScrolling = false;
    }

    function end() {
      window.removeEventListener('wheel', eventHandler);
      window.removeEventListener('touchmove', eventHandler);
      resolve(window.pageYOffset);
    }

    function loop() {
      if (!isScrolling) {
        return end();
      }

      dampScroll = damp(scroll, dampScroll, dampFactor);
      window.scrollTo({
        top: dampScroll
      });

      if (dampScroll === scroll) {
        isScrolling = false;
      }

      return requestAnimationFrame(loop);
    }

    function start(target) {
      isScrolling = true;
      dampScroll = window.pageYOffset;
      scroll = target;
      window.addEventListener('wheel', eventHandler, {
        passive: true
      });
      window.addEventListener('touchmove', eventHandler, {
        passive: true
      });
      loop();
    }

    start(scrollTarget);
  });
}